// extracted by mini-css-extract-plugin
module.exports = {"page":"page-page-TbnIU","nav":"page-nav-1VbLA","content":"page-content-1dczT","main":"page-main-1o3nF","card":"page-card-1OiiY"};